import React from 'react'
import { TrackingContext, TrackingContextProps } from './TrackingContext'

export function useTracking(): TrackingContextProps {
    return React.useContext(TrackingContext)
}